import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-type {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}

#carros-eletricos-type .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.carros-eletricos-type-div-btns {
  width: 245px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-bottom: 1px solid #767676; */
  padding-bottom: 10px;
  margin-bottom: 34px;
}

.carros-eletricos-type-btn {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  color: #222222;
  width: 120px;
  padding-bottom: 10px;
  border-bottom: 1px solid #767676;
}

.carros-eletricos-type-btn.selected {
  color: #cc0000;
  border-bottom: 2px solid #cc0000;
}

.carros-eletricos-type-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.carros-eletricos-type-details-div {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: 60px;
}

.carros-eletricos-type-details-text {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  margin-bottom: 20px;
  width: 90%;
}

.carros-eletricos-type-details-text b {
  color: #444;
  font-weight: 600!important;
}


.carros-eletricos-type-details-img {
  max-width: 456px;
  width: 100%;
}

.carros-eletricos-type-details-circles-mb {
  position: absolute;
  bottom: 40px;
  left: -15px;
  background-image: url('assets/carros-eletricos/circles-type-mobile.png');
  width: 72px;
  height: 41px;
}

.carros-eletricos-type-details-circles-ds {
  display: none;
}

.carros-eletricos-type-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color:#F0F0F0;
}

#carros-eletricos-type .carros-eletricos-type-carousel .ctn {
  align-items: baseline;
  padding-bottom: 32px;
}

.carros-eletricos-type-carousel-title {
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0em;
  color: #444;
  width: 180px;
  margin-bottom: 13px;
  margin-top: 24px;
}

.carros-eletricos-type-carousel-title b {
  font-weight: 800!important;
  /* color: #cc0000; */
}

#carros-eletricos-type .carros-eletricos-type-carousel .bullet {
  background-color: #999999;
  width: 8px !important;
  height: 8px !important;
}

#carros-eletricos-type .carros-eletricos-type-carousel .bullet.active {
  background-color: #cc0000;
  width: 8px !important;
  height: 8px !important;
}

#carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__container {
  gap: 27px;
  max-width: 180px;
}

.carros-eletricos-type-carousel-ctn {
  display: flex;
  flex-direction: column;
  align-self: center;
  gap: 16px;
  max-width: 100%;
  width: 100%;
}

.carros-eletricos-type-carousel .carros-eletricos-type-slide {
  width: 172px;
  height: 144px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  display: flex;
  background-color: #fff;
}

.carros-eletricos-type-slide-ctn {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 32px 24px;
  justify-content: space-between;
}

.carros-eletricos-type-slide-img {
  width: 40px;
  height: 40px;
}

.carros-eletricos-type-slide-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.carros-eletricos-type-slide-txt {
  font-family: 'SantanderText';
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  color: #222222;
}

@media (min-width: 992px) {
  #carros-eletricos-type {
    display: flex;
  }

  #carros-eletricos-type .ctn {
    align-items: center;
  }

  .carros-eletricos-type-div-btns {
    margin-bottom: 0px;
  }

  .carros-eletricos-type-details-div {
    flex-direction: row;
    padding-bottom: 60px;
    align-items: flex-start;
    justify-content: space-between;
  }

  .carros-eletricos-type-details-text {
    max-width: 513px;
    padding-top: 30px;
    width: 100%;
  }

  .carros-eletricos-type-details-text-p2 {
    max-width: 505px;
  }

  .carros-eletricos-type-details-circles-mb {
    display: none;
  }

  .carros-eletricos-type-details-circles-ds {
    display: flex;
    position: absolute;
    top: 50px;
    left: -232px;
    background-image: url('assets/carros-eletricos/circles-type-desktop.png'), url('assets/carros-eletricos/circles-type-desktop.webp');
    width: 239px;
    height: 99px;
    transform: rotate(90deg);
  }

  .carros-eletricos-type-carousel {
    flex-direction: row;
    /* margin: 140px 0px 80px; */
    align-items: flex-start;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .ctn {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 49px 0;
  }

  .carros-eletricos-type-carousel-title {
    width: 231px;
    font-size: 32px;
    line-height: 48px;
    text-align: left;
    margin: 0;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .home-pagination {
    display: none;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__container {
    gap: 25px;
    max-width: 224px;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__viewport {
    padding: 0 44px;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__next,
  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__prev {
    background-color: #F0F0F0;
    height: 100%;
    background-size: 28px 76px;
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__next {
    background-image: url('assets/carros-eletricos/ic-arrow-rigth.svg');
  }

  #carros-eletricos-type .carros-eletricos-type-carousel .custom-carousel .embla__prev {
    background-image: url('assets/carros-eletricos/ic-arrow-left.svg');
  }

  .carros-eletricos-type-carousel-ctn {
    margin-left: 40px;
    max-width: 630px;
  }

  .carros-eletricos-type-carousel .carros-eletricos-type-slide {
    width: 224px;
    height: 188px;
    display: block;
  }

  .carros-eletricos-type-slide-ctn {
    padding: 36px 0 0 26px;
    gap: 15px;
  }

  .carros-eletricos-type-slide-img {
    width: 48px;
    height: 48px;
  }

  .carros-eletricos-type-slide-txt {
    font-family: 'SantanderText';
    font-size: 18px;
    line-height: 28px;
    color: #222222;
  }
}

@media (min-width: 1200px) {
  .carros-eletricos-type-carousel-ctn {
    max-width: 825px;
  }
}

/* @media (min-width: 1400px) {
  .carros-eletricos-type-carousel-ctn {
    max-width: 100%;
  }
} */
`;

export default styles;